import slug from '@teko/slug';
export { DiscoveryService } from './service.es.js';
export { BlockItemType, BlockType, PageTypeEnum } from './types.es.js';
export { useDiscoveryProduct, useDiscoverySearch, useInfiniteDiscoverySearch, usePersonalizeBlocks, useSkus } from './hooks.es.js';
export { SORT_ORDER, SORT_TYPE, SOURCE_VIDEO } from './constants.es.js';
export { cookFilter, getKeyAPI, getObjFromQueryString, getParamsFromUrl, normalizePageBuilderToDiscoveryParams, paramToUrl } from './helpers.es.js';

const getProductUrl = (name, sku) => {
  return `/${slug(name)}--s${sku}?sku=${sku}`;
};

export { getProductUrl };
